import { Region } from 'src/app/shared/model/region.interface';
import { WaveSurfer } from 'wavesurfer.js';
const pasteAudio = (cutSelection: { length: any; getChannelData: (arg0: number) => any; duration: any; },
                    instance: WaveSurfer) => {
    const offlineAudioContext = instance.backend.ac;
    const originalAudioBuffer = instance.backend.buffer;

    const cursorPosition = instance.getCurrentTime();
    const newAudioBuffer = offlineAudioContext.createBuffer(
        originalAudioBuffer.numberOfChannels,
        originalAudioBuffer.length + cutSelection.length,
        originalAudioBuffer.sampleRate);

    for (let channel = 0; channel < originalAudioBuffer.numberOfChannels; channel++) {

        const newChannelData = newAudioBuffer.getChannelData(channel);
        const emptySegmentData = cutSelection.getChannelData(channel);
        const originalChannelData = originalAudioBuffer.getChannelData(channel);

        const beforeData = originalChannelData.subarray(0, cursorPosition * originalAudioBuffer.sampleRate);
        const midData = emptySegmentData;
        const afterData = originalChannelData.subarray(Math.floor(cursorPosition * originalAudioBuffer.sampleRate),
            (originalAudioBuffer.length * originalAudioBuffer.sampleRate));


        newChannelData.set(beforeData);
        newChannelData.set(midData, (cursorPosition * newAudioBuffer.sampleRate));
        newChannelData.set(afterData, (cursorPosition + cutSelection.duration) * newAudioBuffer.sampleRate);
    }
    return newAudioBuffer;
};

const cut = (region: Region,
             instance: { backend: { buffer: any; ac: any; }; }) => {

    const start = region.start;
    const end = region.end;
    const originalAudioBuffer = instance.backend.buffer;
    const offlineAudioContext = instance.backend.ac;


    const lengthInSamples = Math.floor((end - start) * originalAudioBuffer.sampleRate);


    const emptySegment = offlineAudioContext.createBuffer(
        originalAudioBuffer.numberOfChannels,
        lengthInSamples,
        originalAudioBuffer.sampleRate);

    const newAudioBuffer = offlineAudioContext.createBuffer(
        originalAudioBuffer.numberOfChannels,
        (start === 0 ? (originalAudioBuffer.length - emptySegment.length) : originalAudioBuffer.length),
        originalAudioBuffer.sampleRate);

    for (let channel = 0; channel < originalAudioBuffer.numberOfChannels; channel++) {

        const newChannelData = newAudioBuffer.getChannelData(channel);
        const emptySegmentData = emptySegment.getChannelData(channel);
        const originalChannelData = originalAudioBuffer.getChannelData(channel);

        const beforeData = originalChannelData.subarray(0, start * originalAudioBuffer.sampleRate);
        const midData = originalChannelData.subarray(start * originalAudioBuffer.sampleRate, end * originalAudioBuffer.sampleRate);
        const afterData = originalChannelData.subarray(Math.floor(end * originalAudioBuffer.sampleRate),
            (originalAudioBuffer.length * originalAudioBuffer.sampleRate));

        emptySegmentData.set(midData);
        if (start > 0) {
            newChannelData.set(beforeData);
            newChannelData.set(afterData, (start * newAudioBuffer.sampleRate));
        } else {
            newChannelData.set(afterData);
        }
    }
    return {
        newAudioBuffer,
        cutSelection: emptySegment
    };
};

const copy = (region: Region,
              instance: WaveSurfer) => {

    const segmentDuration = region.end - region.start;

    const originalBuffer = instance.backend.buffer;
    const emptySegment = instance.backend.ac.createBuffer(
        originalBuffer.numberOfChannels,
        segmentDuration * originalBuffer.sampleRate,
        originalBuffer.sampleRate
    );
    for (let i = 0; i < originalBuffer.numberOfChannels; i++) {
        const chanData = originalBuffer.getChannelData(i);
        const emptySegmentData = emptySegment.getChannelData(i);
        const midData = chanData.subarray(region.start * originalBuffer.sampleRate, region.end * originalBuffer.sampleRate);
        emptySegmentData.set(midData);
    }

    return emptySegment;
};


const cutAudioInSpecificTimeInSeconds = (region: Region,
                                         instance: WaveSurfer) => {
    const start = region.start;
    const end = region.end;

    const originalAudioBuffer = instance.backend.buffer;
    const offlineAudioContext = instance.backend.ac;

    const lengthInSamples = Math.floor((end - start) * originalAudioBuffer.sampleRate);


    try {

        const cutSegment = offlineAudioContext.createBuffer(
            originalAudioBuffer.numberOfChannels,
            lengthInSamples,
            originalAudioBuffer.sampleRate);

        for (let channel = 0; channel < originalAudioBuffer.numberOfChannels; channel++) {

            const newSegment = cutSegment.getChannelData(channel);
            const originalChannelData = originalAudioBuffer.getChannelData(channel);

            const segmentCut = originalChannelData.subarray(start * originalAudioBuffer.sampleRate, end * originalAudioBuffer.sampleRate);


            newSegment.set(segmentCut);
        }
        return cutSegment;
    } catch (error) {
        console.error('Error', error);

    }
};

const bufferToWave = (abuffer: {
    numberOfChannels: number; sampleRate: number;
    getChannelData: (arg0: any) => any;
},                    offset: number, len: number) => {

    const numOfChan = abuffer.numberOfChannels;
    const length = len * numOfChan * 2 + 44;
    const buffer = new ArrayBuffer(length);
    const view = new DataView(buffer);
    const channels = [];
    let i: number;
    let sample: number;
    let pos = 0;

    // write WAVE header
    setUint32(0x46464952);                         // "RIFF"
    setUint32(length - 8);                         // file length - 8
    setUint32(0x45564157);                         // "WAVE"

    setUint32(0x20746d66);                         // "fmt " chunk
    setUint32(16);                                 // length = 16
    setUint16(1);                                  // PCM (uncompressed)
    setUint16(numOfChan);
    setUint32(abuffer.sampleRate);
    setUint32(abuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
    setUint16(numOfChan * 2);                      // block-align
    setUint16(16);                                 // 16-bit (hardcoded in this demo)

    setUint32(0x61746164);                         // "data" - chunk
    setUint32(length - pos - 4);                   // chunk length

    // write interleaved data
    for (i = 0; i < abuffer.numberOfChannels; i++) {
        channels.push(abuffer.getChannelData(i));
    }

    while (pos < length) {
        for (i = 0; i < numOfChan; i++) {             // interleave channels
            sample = Math.max(-1, Math.min(1, channels[i][offset])); // clamp
            sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767) | 0; // scale to 16-bit signed int
            view.setInt16(pos, sample, true);          // update data chunk
            pos += 2;
        }
        offset++;                                     // next source sample
    }

    // create Blob
    return new Blob([buffer], { type: 'audio/mpeg' });

    function setUint16(data: number) {
        view.setUint16(pos, data, true);
        pos += 2;
    }

    function setUint32(data: number) {
        view.setUint32(pos, data, true);
        pos += 4;
    }
};


export {
    cutAudioInSpecificTimeInSeconds,
    pasteAudio,
    copy,
    cut,
    bufferToWave
};
